import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import inventoryCountService from '../../services/inventoryCountService';
import InventoryCountWorkPanel from '../../components/Audit/InventoryCountWorkPanel';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import Toast from '../../components/Common/Toast';

function formatDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('es-PE');
}

export default function AuditMyInventoryCountsPage() {
  const { warehouseId, campaignId } = useParams();
  const { kardexAuditModuleEnabled } = useModuleSettings();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    if (!kardexAuditModuleEnabled) return;
    inventoryCountService
      .myAssignments()
      .then((res) => {
        if (res.success) setAssignments(res.data || []);
      })
      .catch(() => {
        setToast({ isOpen: true, message: 'Error al cargar sus campañas', type: 'error' });
      })
      .finally(() => setLoading(false));
  }, [kardexAuditModuleEnabled]);

  if (!kardexAuditModuleEnabled) {
    return <div className="p-6 text-gray-600">El módulo de auditoría no está habilitado.</div>;
  }

  if (warehouseId && campaignId) {
    return (
      <div className="p-6 max-w-4xl mx-auto">
        <nav className="text-sm text-gray-600 mb-4">
          <Link to="/audit/kardex" className="hover:text-teal-600">Auditoría</Link>
          <span className="mx-2">/</span>
          <Link to="/audit/my-inventory-counts" className="hover:text-teal-600">Mis tomas de inventario</Link>
          <span className="mx-2">/</span>
          <span className="text-gray-800">Realizar conteo</span>
        </nav>
        <InventoryCountWorkPanel
          warehouseId={warehouseId}
          campaignId={campaignId}
          backTo="/audit/my-inventory-counts"
        />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <nav className="text-sm text-gray-600 mb-3">
        <Link to="/audit/kardex" className="hover:text-teal-600">Auditoría</Link>
        <span className="mx-2">/</span>
        <span className="text-gray-800">Mis tomas de inventario</span>
      </nav>

      <h1 className="text-2xl font-bold text-gray-800 mb-2">Mis tomas de inventario</h1>
      <p className="text-sm text-gray-600 mb-6">
        Campañas activas en almacenes donde usted está asignado como responsable (Destinatarios → Alertas inventario).
      </p>

      {loading ? (
        <p className="text-gray-500">Cargando…</p>
      ) : assignments.length === 0 ? (
        <div className="p-4 bg-white border rounded-lg text-sm text-gray-600">
          No tiene campañas activas asignadas. Si debe contar inventario, pida al administrador que lo asigne en{' '}
          <Link to="/audit/recipients" className="text-teal-700 hover:underline">Destinatarios</Link>.
        </div>
      ) : (
        <div className="space-y-3">
          {assignments.map((c) => (
            <div key={c.id} className="p-4 bg-white border rounded-lg flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-medium text-gray-900">{c.name}</p>
                <p className="text-sm text-gray-600">
                  {c.warehouse?.name || 'Almacén'} · Progreso {c.progress_label}
                </p>
                <p className="text-xs text-gray-500 mt-1">Límite: {formatDateTime(c.ends_at)}</p>
              </div>
              <Link
                to={`/audit/my-inventory-counts/${c.warehouse_id}/${c.id}`}
                className="px-4 py-2 bg-teal-600 text-white rounded text-sm hover:bg-teal-700"
              >
                Realizar conteo
              </Link>
            </div>
          ))}
        </div>
      )}

      <Toast {...toast} onClose={() => setToast((t) => ({ ...t, isOpen: false }))} />
    </div>
  );
}
